import { Grid2 } from '@mui/material';
import { CSSProperties } from 'react';

import Material from '../material/Material';
import { ISimplifiedVisualMaterial } from 'api';

type Props = {
  visualMaterials: ISimplifiedVisualMaterial[];
  onItemClick?: (materialId: ISimplifiedVisualMaterial['id']) => void;
  currentSelectedId?: string[];
  disabled?: boolean;
  imgStyles?: CSSProperties;
};

const Materials = (props: Props) => {
  const { visualMaterials, onItemClick, currentSelectedId, disabled, imgStyles = {} } = props;
  const handleSelect = (id: string) => onItemClick?.(id);

  return (
    <Grid2 container spacing={2} sx={{ width: '100%' }}>
      {visualMaterials?.map(material => {
        return (
          <Grid2 key={material.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <Material
              imgStyles={imgStyles}
              visualMaterial={material}
              selected={currentSelectedId?.includes(material.id) ?? false}
              onClickCard={handleSelect}
              displayTooltip
              disabled={disabled}
            />
          </Grid2>
        );
      })}
    </Grid2>
  );
};

export default Materials;
